export const categories = {
  revenues: [
    { id: 'cat_servicos', name: 'Serviços', active: true },
    { id: 'cat_produtos', name: 'Produtos', active: true },
    { id: 'cat_consultoria', name: 'Consultoria', active: true },
    { id: 'cat_outros_rec', name: 'Outros', active: true },
  ],
  expenses: [
    { id: 'cat_infra', name: 'Infraestrutura', active: true },
    { id: 'cat_software', name: 'Software', active: true },
    { id: 'cat_marketing', name: 'Marketing', active: true },
    { id: 'cat_impostos', name: 'Impostos', active: true },
    { id: 'cat_pessoal', name: 'Pessoal', active: true },
    { id: 'cat_admin', name: 'Administrativo', active: true },
    { id: 'cat_outros_desp', name: 'Outros', active: true },
  ],
};
